module.exports = __webpack_public_path__ + "static/media/icon_inconformity.d8fc0a2c.svg";